import { Options, SDK as RAW } from '../index';
import { InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import {
    LocalStorageWrapper,
    persistCache,
    PersistentStorage,
} from 'apollo3-cache-persist';
import { PersistedData } from 'apollo3-cache-persist/lib/types';
import { LoginMd5Input, LoginResult } from '../generated/graphql';
import { loginByMD5 } from '../features/directLogin';
import { ResultSuccess } from '../types';

interface DeindateSDK extends RAW {
    loginByMD5: (data: LoginMd5Input) => Promise<LoginResult | ResultSuccess>;
}

const init = (x: DeindateSDK): DeindateSDK => {
    x.loginByMD5 = async (data: LoginMd5Input) => {
        return loginByMD5(data, x);
    };
    return x;
};

export class SDK extends RAW {
    static async Init(
        options: Options,
        errorCallback: (message: unknown) => unknown,
    ): Promise<SDK> {
        const cache = new InMemoryCache();
        await persistCache({
            cache,
            storage: new LocalStorageWrapper(
                window.localStorage,
            ) as PersistentStorage<PersistedData<NormalizedCacheObject>>,
        });
        return new SDK(options, cache, errorCallback);
    }
    constructor(
        options: Options,
        cache: InMemoryCache,
        errorCallback: (message: unknown) => unknown,
    ) {
        super(options, cache, errorCallback);
        return init(this);
    }

    loginByMD5 = async (
        data: LoginMd5Input,
    ): Promise<ResultSuccess | LoginResult> => {
        return loginByMD5(data, this);
    };
}
